import React, { useState, useEffect } from 'react';
import { toast } from 'react-toast';
import axiosInstance from '../../api/axiosInstance';
import '../../styles/modal.css';

const WorkXiqSettingsModal = ({
  isOpen,
  onClose,
  onConnectSuccess,
  isEditMode = false,
  initialCredentials = null,
}) => {
  const [username, setUsername] = useState('');
  const [appToken, setAppToken] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isOpen && isEditMode && initialCredentials) {
      setUsername(initialCredentials.username || '');
      setAppToken(initialCredentials.app_token || '');
    } else if (isOpen && !isEditMode) {
      setUsername('');
      setAppToken('');
    }
    setError(null);
  }, [isOpen, isEditMode, initialCredentials]);

  const validateForm = () => {
    if (!username.trim()) {
      setError('Username is required');
      return false;
    }
    if (!appToken.trim()) {
      setError('App Token is required');
      return false;
    }
    setError(null);
    return true;
  };

  const handleSave = async () => {
    if (!validateForm()) {
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      // API call commented out for now - uncomment when API is available
      const endpoint = isEditMode ? '/pulse/update_project_pulse_cred' : '/pulse/add_project_pulse_cred';
      const method = isEditMode ? 'put' : 'post';
      
      const response = isEditMode
        ? await axiosInstance.put(endpoint, {
            username: username.trim(),
            app_token: appToken.trim(),
            is_connected: true
          })
        : await axiosInstance.post(endpoint, {
            username: username.trim(),
            app_token: appToken.trim(),
            is_connected: true
          });

      if (response.status_code === 200 || response.status_code === 201) {
        // toast.success(
        //   isEditMode
        //     ? 'WorkXiq settings updated successfully'
        //     : 'WorkXiq connected successfully',
        //   {
        //     position: 'top-right',
        //     duration: 3000,
        //   }
        // );
        onConnectSuccess();
        onClose();
      } else {
        throw new Error(response.data?.message || 'Failed to save WorkXiq settings');
      }

    } catch (error) {
      console.error('Error saving WorkXiq settings:', error);
      const errorMessage = error.response?.data?.message || 'Failed to save WorkXiq settings';
      setError(errorMessage);
      toast.error(errorMessage, {
        position: 'top-right',
        duration: 3000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div data-rt-modal-overlay className="modal-overlay" onClick={(e) => { if (e.target === e.currentTarget) { const b = e.currentTarget.querySelector('[data-rt-modal-close], .close-btn, .modal-close, button[aria-label="Close"], button[aria-label="close"]'); if (b) b.click(); } }}>
      <div className="modal create-project-modal">
        <div className="modal-header">
          <h2>{isEditMode ? 'Update WorkXiq Settings' : 'Connect WorkXiq'}</h2>
          <button
            type="button"
            className="modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <div className="modal-content">
          <div className="form-group">
            <label className="form-label">Username</label>
            <input
              id="projectpulse-username"
              type="text"
              className="form-input"
              placeholder="Enter your WorkXiq username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              disabled={isLoading}
              style={{ width: '100%' }}
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label">App Token</label>
            <input
              id="projectpulse-app-token"
              type="password"
              className="form-input"
              placeholder="Enter your WorkXiq App Token"
              value={appToken}
              onChange={(e) => setAppToken(e.target.value)}
              disabled={isLoading}
              style={{ width: '100%' }}
              required
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <div className="modal-actions">
            <button
              type="button"
              className="btn-secondary"
              onClick={onClose}
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn-primary"
              onClick={handleSave}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <span className="spinner"></span> {isEditMode ? 'Updating...' : 'Saving...'}
                </>
              ) : isEditMode ? (
                'Update Configuration'
              ) : (
                'Save Configuration'
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkXiqSettingsModal;
